import { render, staticRenderFns } from "./ComparisonBarChartV2.vue?vue&type=template&id=0aac8710&scoped=true&"
import script from "./ComparisonBarChartV2.vue?vue&type=script&lang=ts&"
export * from "./ComparisonBarChartV2.vue?vue&type=script&lang=ts&"
import style0 from "./ComparisonBarChartV2.vue?vue&type=style&index=0&id=0aac8710&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aac8710",
  null
  
)

export default component.exports